import React, { Component } from 'react';
import { translate } from '../Services/translation';

class OrganizationSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    render() {
        const {
            query,
            result,
            showResult,
            onSearch,
            selectedItem,
            selectOrganization,
            redirectUrl,
        } = this.props;
        return (
            <div className="select-organization">
                <div className="select-organization__search" role="search">
                    {
                        <h1 className="select-organization__search__title">
                            {translate('organization.search.title')}
                        </h1>
                    }
                    <div
                        className={`select-organization__search__form`}
                        role="search"
                    >
                        <input
                            className="select-organization__search__input"
                            type="search"
                            placeholder={translate('general.search')}
                            autoComplete="off"
                            value={decodeURIComponent(query)}
                            onChange={event =>
                                onSearch(encodeURIComponent(event.target.value))
                            }
                            ref={input => {
                                this.searchInput = input;
                            }}
                        />
                    </div>

                    <div className="select-organization-result__container">
                        {showResult && (
                            <ul className="select-organization-result__result">
                                {result &&
                                    result.map((item, index, array) => (
                                        <div key={`${item.name}-${index}`}>
                                            <li
                                                className={`select-organization-result__result__item ${
                                                    selectedItem === index
                                                        ? 'select-organization-result__result__item--selected'
                                                        : ''
                                                }`}
                                            >
                                                <a
                                                    className={`select-organization-result__result__link`}
                                                    onClick={() =>
                                                        selectOrganization(
                                                            item.id,
                                                            redirectUrl
                                                                ? redirectUrl
                                                                : '/',
                                                        )
                                                    }
                                                >
                                                    <div>{item.name}</div>
                                                </a>
                                            </li>
                                        </div>
                                    ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default OrganizationSearch;
